/*
  Safir storefront, Goldie format: behavior for sections/sg-buy.liquid and
  sections/sg-sticky.liquid.

  Buy box: the pack, flavor and frequency radios live outside the theme's
  product-form-component. This script writes the chosen variant id and
  selling plan into that form's hidden inputs and repaints prices from the
  live variant data serialised by snippets/sg-buy-product-json.liquid. The
  theme's product-form.js still does the add to cart, so the cart drawer,
  bubble and pre-order layer behave exactly as on any other button.

  Plain script, no imports, loaded with defer.
*/
(function () {
  'use strict';

  function moneyFormatter(format) {
    var fmt = format || '${{amount}}';
    function delimit(cents, decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return function (cents) {
      var value = Math.round(Number(cents) || 0);
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
        switch (key) {
          case 'amount_no_decimals':
            return delimit(value, 0, ',', '.');
          case 'amount_with_comma_separator':
            return delimit(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return delimit(value, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return delimit(value, 2, "'", '.');
          default:
            return delimit(value, 2, ',', '.');
        }
      });
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function plural(unit, size) {
    return size === 1 ? unit : unit + 's';
  }

  /* ------------------------------------------------------------------ */
  /* Buy box                                                              */
  /* ------------------------------------------------------------------ */

  function BuyBox(root) {
    var dataEl = root.querySelector('script[data-sg-data]');
    if (!dataEl) return;

    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('[safir-g] Buy box data is not valid JSON', error);
      return;
    }

    this.root = root;
    this.money = moneyFormatter(this.data.moneyFormat);
    this.text = this.data.text || {};
    this.byId = {};
    for (var i = 0; i < this.data.products.length; i++) {
      this.byId[String(this.data.products[i].id)] = this.data.products[i];
    }

    var start = this.data.start;
    var product = this.byId[String(start.productId)];
    if (!product) return;

    this.state = {
      productId: String(start.productId),
      variantId: String(start.variantId),
      planId: start.planId === '' || start.planId == null ? '' : String(start.planId),
      imageIndex: 0
    };
    var variant = this.findVariant(product, this.state.variantId);
    this.state.size = variant ? variant.size : 0;

    this.sectionKey = (root.querySelector('input[name^="sg-pack-"]') || {}).name || 'sg-pack-sg';
    this.uid = this.sectionKey.replace(/^sg-pack-/, '');
    this.form = root.querySelector('product-form-component');
    this.idInput = root.querySelector('product-form-component input[name="id"]');
    this.planInput = root.querySelector('[data-sg-plan-input]');
    this.packsEl = root.querySelector('[data-sg-packs]');
    this.plansEl = root.querySelector('[data-sg-plans]');
    this.planStep = root.querySelector('[data-sg-step="plan"]');
    this.summaryEl = root.querySelector('[data-sg-summary]');
    this.titleEl = root.querySelector('[data-sg-title]');
    this.mainImg = root.querySelector('.sg-buy__main img');
    this.thumbsEl = root.querySelector('[data-sg-thumbs]');

    root.addEventListener('change', this.onChange.bind(this));
    if (this.thumbsEl) this.thumbsEl.addEventListener('click', this.onThumb.bind(this));

    this.preorderNotes();
    this.render(false);
  }

  BuyBox.prototype.findVariant = function (product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  };

  /* When moving to another flavor, keep the same pack size if it can be
     bought, else the "Most popular" pack, else the first available one. */
  BuyBox.prototype.pickVariant = function (product, size) {
    var v;
    var i;
    for (i = 0; i < product.variants.length; i++) {
      v = product.variants[i];
      if (v.available && size && v.size === size) return v;
    }
    for (i = 0; i < product.variants.length; i++) {
      v = product.variants[i];
      if (v.available && v.popular) return v;
    }
    for (i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0] || null;
  };

  /* Selling plan to use for a variant: the current one if the variant
     supports it, else its first plan. Returns '' for one-time purchase. */
  BuyBox.prototype.pickPlan = function (product, variant, wanted) {
    if (!variant) return '';
    var ids = Object.keys(variant.plans || {});
    if (!ids.length) return '';
    if (wanted === '' && !product.requiresPlan) return '';
    if (wanted && ids.indexOf(String(wanted)) !== -1) return String(wanted);
    return ids[0];
  };

  BuyBox.prototype.planLabel = function (product, planId) {
    for (var i = 0; i < product.plans.length; i++) {
      if (String(product.plans[i].id) === String(planId)) return product.plans[i].label;
    }
    return '';
  };

  BuyBox.prototype.priceFor = function (variant, planId) {
    if (planId && variant.plans && variant.plans[planId] != null) {
      return { now: variant.plans[planId], was: variant.price };
    }
    return { now: variant.price, was: variant.compare > variant.price ? variant.compare : 0 };
  };

  BuyBox.prototype.onChange = function (event) {
    var input = event.target;
    if (!input || !input.name) return;
    var product = this.byId[this.state.productId];

    if (input.name.indexOf('sg-pack-') === 0) {
      var variant = this.findVariant(product, input.value);
      if (!variant) return;
      this.state.variantId = String(variant.id);
      this.state.size = variant.size;
      this.state.planId = this.pickPlan(product, variant, this.state.planId);
      this.render(false);
    } else if (input.name.indexOf('sg-flavor-') === 0) {
      var next = this.byId[String(input.value)];
      if (!next) return;
      var picked = this.pickVariant(next, this.state.size);
      if (!picked) return;
      this.state.productId = String(next.id);
      this.state.variantId = String(picked.id);
      this.state.size = picked.size;
      this.state.planId = this.pickPlan(next, picked, this.state.planId);
      this.state.imageIndex = 0;
      this.render(true);
    } else if (input.name.indexOf('sg-plan-') === 0) {
      var current = this.findVariant(product, this.state.variantId);
      this.state.planId = input.value === '' ? this.pickPlan(product, current, '') : this.pickPlan(product, current, input.value);
      this.render(false);
    }
  };

  BuyBox.prototype.onThumb = function (event) {
    var button = event.target.closest('[data-sg-thumb]');
    if (!button) return;
    this.state.imageIndex = Number(button.getAttribute('data-sg-thumb')) || 0;
    this.renderGallery();
  };

  BuyBox.prototype.render = function (flavorChanged) {
    var product = this.byId[this.state.productId];
    var variant = this.findVariant(product, this.state.variantId);
    if (!product || !variant) return;

    this.renderPacks(product, variant);
    this.renderPlans(product, variant);
    this.syncChecked();
    this.syncForm(product, variant);
    this.renderSummary(product, variant);

    if (flavorChanged) {
      this.renderGallery();
      if (this.titleEl && this.data.mode === 'product') this.titleEl.textContent = product.heading || product.title;
      if (this.data.mode === 'product' && window.history && window.history.replaceState) {
        var url = product.url + '?variant=' + variant.id;
        window.history.replaceState(window.history.state, '', url);
      }
    }
  };

  BuyBox.prototype.renderPacks = function (product, variant) {
    if (!this.packsEl) return;
    var self = this;
    var planId = this.state.planId;
    var best = null;

    product.variants.forEach(function (v) {
      if (!v.available || v.size < 2) return;
      var per = self.priceFor(v, planId).now / v.size;
      if (best === null || per < best.per - 0.0001) best = { id: v.id, per: per };
    });

    var html = product.variants
      .map(function (v) {
        var price = self.priceFor(v, planId);
        var checked = String(v.id) === String(variant.id);
        var sub = v.size > 0 ? v.size + ' ' + plural(product.unit, v.size) : '';
        if (!v.available) {
          sub += (sub ? ' · ' : '') + (self.text.soldOut || 'Sold out');
        } else if (best && best.id === v.id && product.variants.length > 2 && self.text.bestValue) {
          sub += (sub ? ' · ' : '') + self.text.bestValue.replace('[unit]', product.unit);
        }
        var per = v.size > 1 ? Math.round(price.now / v.size) : 0;
        return (
          '<label class="sg-opt' +
          (checked ? ' is-checked' : '') +
          (v.available ? '' : ' is-disabled') +
          '">' +
          '<input type="radio" name="' +
          escapeHtml(self.sectionKey) +
          '" value="' +
          v.id +
          '"' +
          (checked ? ' checked' : '') +
          (v.available ? '' : ' disabled') +
          '>' +
          '<span class="sg-opt__radio" aria-hidden="true"></span>' +
          '<span class="sg-opt__main"><span class="sg-opt__name">' +
          escapeHtml(v.label) +
          (v.popular ? '<span class="sg-badge">' + escapeHtml(self.text.popular || 'Most popular') + '</span>' : '') +
          '</span><span class="sg-opt__sub">' +
          escapeHtml(sub) +
          '</span></span>' +
          '<span class="sg-opt__price">' +
          (price.was > price.now ? '<s>' + escapeHtml(self.money(price.was)) + '</s>' : '') +
          '<span>' +
          escapeHtml(self.money(price.now)) +
          '</span>' +
          (per ? '<span class="sg-opt__per">' + escapeHtml(self.money(per)) + ' / ' + escapeHtml(product.unit) + '</span>' : '') +
          '</span></label>'
        );
      })
      .join('');

    this.packsEl.innerHTML = html;
  };

  BuyBox.prototype.renderPlans = function (product, variant) {
    if (!this.plansEl || !this.planStep) return;
    var planIds = Object.keys(variant.plans || {});
    if (!planIds.length) {
      this.planStep.hidden = true;
      this.plansEl.innerHTML = '';
      return;
    }
    this.planStep.hidden = false;

    var subId = this.state.planId || planIds[0];
    var subPrice = variant.plans[subId];
    var pct = Math.round(((variant.price - subPrice) / variant.price) * 100);
    var groupName = 'sg-plan-' + this.uid;
    var label = this.planLabel(product, subId);
    var subscribing = this.state.planId !== '';

    var perks = '';
    if (pct > 0) perks += '<span>' + pct + '% off every delivery</span>';
    if (this.text.subPerk) perks += '<span>' + escapeHtml(this.text.subPerk) + '</span>';

    var html =
      '<label class="sg-opt sg-plan' +
      (subscribing ? ' is-checked' : '') +
      '">' +
      '<input type="radio" name="' +
      escapeHtml(groupName) +
      '" value="' +
      escapeHtml(subId) +
      '"' +
      (subscribing ? ' checked' : '') +
      '>' +
      (pct > 0 ? '<span class="sg-plan__flag">Save ' + pct + '%</span>' : '') +
      '<span class="sg-plan__row"><span class="sg-opt__radio" aria-hidden="true"></span>' +
      '<span class="sg-opt__main"><span class="sg-opt__name">' +
      escapeHtml(this.text.subLabel || 'Subscribe & save') +
      '</span><span class="sg-opt__sub">' +
      escapeHtml(label) +
      '</span></span>' +
      '<span class="sg-opt__price"><s>' +
      escapeHtml(this.money(variant.price)) +
      '</s><span>' +
      escapeHtml(this.money(subPrice)) +
      '</span></span></span>' +
      (perks ? '<span class="sg-plan__perks">' + perks + '</span>' : '') +
      '</label>';

    if (!product.requiresPlan) {
      html +=
        '<label class="sg-opt sg-plan' +
        (subscribing ? '' : ' is-checked') +
        '">' +
        '<input type="radio" name="' +
        escapeHtml(groupName) +
        '" value=""' +
        (subscribing ? '' : ' checked') +
        '>' +
        '<span class="sg-plan__row"><span class="sg-opt__radio" aria-hidden="true"></span>' +
        '<span class="sg-opt__main"><span class="sg-opt__name">' +
        escapeHtml(this.text.onceLabel || 'One-time purchase') +
        '</span></span>' +
        '<span class="sg-opt__price"><span>' +
        escapeHtml(this.money(variant.price)) +
        '</span></span></span></label>';
    }

    this.plansEl.innerHTML = html;
  };

  /* Flavor radios are static markup; only their checked state moves. */
  BuyBox.prototype.syncChecked = function () {
    var productId = this.state.productId;
    this.root.querySelectorAll('input[name^="sg-flavor-"]').forEach(function (input) {
      var on = input.value === productId;
      input.checked = on;
      var label = input.closest('.sg-opt');
      if (label) label.classList.toggle('is-checked', on);
    });
  };

  BuyBox.prototype.syncForm = function (product, variant) {
    if (this.idInput) this.idInput.value = String(variant.id);
    if (this.planInput) {
      this.planInput.value = this.state.planId;
      this.planInput.disabled = this.state.planId === '';
    }
    if (this.form) this.form.dataset.productId = String(product.id);

    var container = this.root.querySelector('add-to-cart-component');
    var button = this.root.querySelector('product-form-component button[name="add"]');
    if (button) button.disabled = !variant.available;
    if (container && product.images.length) {
      container.setAttribute('data-product-variant-media', product.images[0].thumb);
    }
  };

  BuyBox.prototype.renderSummary = function (product, variant) {
    if (!this.summaryEl) return;
    if (this.state.planId === '' || !this.text.renews) {
      this.summaryEl.textContent = '';
      return;
    }
    var price = this.priceFor(variant, this.state.planId).now;
    var label = this.planLabel(product, this.state.planId).toLowerCase();
    this.summaryEl.textContent = this.text.renews
      .replace('[price]', this.money(price))
      .replace('[plan]', label || 'on schedule');
  };

  BuyBox.prototype.renderGallery = function () {
    var product = this.byId[this.state.productId];
    if (!product || !this.mainImg) return;
    var images = product.images;
    var index = Math.min(this.state.imageIndex, Math.max(images.length - 1, 0));
    var image = images[index];
    if (image) {
      this.mainImg.src = image.src;
      this.mainImg.srcset = image.srcset;
      this.mainImg.alt = image.alt;
      this.mainImg.width = image.w;
      this.mainImg.height = image.h;
    }
    if (!this.thumbsEl) return;
    this.thumbsEl.hidden = images.length < 2;
    this.thumbsEl.innerHTML = images
      .map(function (img, i) {
        return (
          '<button type="button" class="sg-buy__thumb" data-sg-thumb="' +
          i +
          '" aria-label="Show image ' +
          (i + 1) +
          '"' +
          (i === index ? ' aria-current="true"' : '') +
          '><img src="' +
          escapeHtml(img.thumb) +
          '" alt="" loading="lazy" width="200" height="200"></button>'
        );
      })
      .join('');
  };

  /* The pre-order layer (snippets/safir-preorder.liquid) publishes its
     config on window.SAFIR_PREORDER. When it is on, each flavor shows the
     same short ship date ("Ships Oct 27") the rest of the store uses. */
  BuyBox.prototype.preorderNotes = function () {
    var cfg = window.SAFIR_PREORDER;
    if (!cfg || !cfg.shipShort) return;
    var note = cfg.shipShort;
    this.root.querySelectorAll('[data-sg-flavor-sub]').forEach(function (el) {
      if (!el.textContent.trim()) el.textContent = note;
    });
  };

  /* ------------------------------------------------------------------ */
  /* Sticky bar                                                           */
  /* ------------------------------------------------------------------ */

  function Sticky(bar) {
    var hero = document.querySelector('[data-sg-hero]');
    var buy = document.getElementById('safir-buy');
    var heroPast = false;
    var buyIn = false;
    var buyPast = false;

    var sub = bar.querySelector('[data-sg-sticky-sub]');
    var cfg = window.SAFIR_PREORDER;
    if (sub && !sub.textContent.trim() && cfg && cfg.stickyLabel) sub.textContent = cfg.stickyLabel;

    function sync() {
      var on = !buyIn && (heroPast || buyPast);
      bar.classList.toggle('is-on', on);
      if (on) {
        bar.removeAttribute('inert');
        bar.removeAttribute('aria-hidden');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    if (!('IntersectionObserver' in window)) return;

    if (hero) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        heroPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        sync();
      }).observe(hero);
    }
    if (buy) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        buyIn = e.isIntersecting;
        buyPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        sync();
      }).observe(buy);
    }
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-sg-buy]').forEach(function (root) {
      if (root.dataset.sgReady) return;
      root.dataset.sgReady = '1';
      new BuyBox(root);
    });
    document.querySelectorAll('[data-sg-sticky]').forEach(function (bar) {
      if (bar.dataset.sgReady) return;
      bar.dataset.sgReady = '1';
      Sticky(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: sections re-render in place. */
  document.addEventListener('shopify:section:load', boot);
})();
